import { render, staticRenderFns } from "./publish-preview-button.vue?vue&type=template&id=4dd76a81"
import script from "./publish-preview-button.vue?vue&type=script&lang=js"
export * from "./publish-preview-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports